import { data } from "react-router-dom";
import axiosInstance from "./axiosInstance";

const api = {
  login: (userData) => axiosInstance.post("/userLogin", userData),
  registerUser: (userData) => axiosInstance.post("/registerUser", userData),
  sendOtp:(data)=>axiosInstance.post("/send-otp", data),
  VerifyOtp:(data)=>axiosInstance.post("/verify-otp",data),
  resetPass:(data)=>axiosInstance.post("/reset-password",data),
   getPropertyId:(propertyReferralCode,userReferralCode)=>axiosInstance.get(`/getPropertyId/${propertyReferralCode}/${userReferralCode}`),
  getProjectId:(propertyReferralCode,userReferralCode)=>axiosInstance.get(`/getProjectId/${propertyReferralCode}/${userReferralCode}`),
  getApartmentId:(propertyReferralCode,userReferralCode)=>axiosInstance.get(`/getApartmentId/${propertyReferralCode}/${userReferralCode}`)
};
const investorApi = {
  getReferrals:()=>axiosInstance.get("/getReferrals"),
  checkPhone:(data)=>axiosInstance.post("/checkPhone",data),
  verifyEmail:(data)=>axiosInstance.post("/verifyEmail",data),
  CheckEmail:(data)=>axiosInstance.post("/check-email",data),
  userLogin:(data)=>axiosInstance.post("/login",data),
  SendEmailOtp:(data)=>axiosInstance.post("/send-email-otp",data),
  VerifyOtp:(data)=>axiosInstance.post("/verify-email-otp",data),
  getInvestmentTrend: (id) => axiosInstance.get("/getSaleTransaction/5"),
  getPropertyDetails: (id) => axiosInstance.get(`getPropertyDetailsById/${id}`),
  getIndependentHouseById:(id) => axiosInstance.get(`/getIndependentHouseById/${id}`),
  saveDevice: (data) => axiosInstance.post("/addDevice", data),
  getInvestorSummary: (id) => axiosInstance.get(`/getInvestorSummary/${id}`),
  getInvestmentProperties: (id) =>
    axiosInstance.get(`/getInvestmentProperties/${id}`),
  getPropertyMarketRange: (id) =>
    axiosInstance.get(`/getPropertyMarketRange/${id}`),
  getPropertyMarketRange: (id) => axiosInstance.get(`/getAllInvestments`),
  getPropertiesAndProjects: (userId) =>
    axiosInstance.get(`/getPropertiesAndProjects`),

  editProfile: (id, userData) =>
    axiosInstance.post(`editProfile/${id}`, userData),
  updatePassword: (id, userData) =>
    axiosInstance.post(`updatePassword/${id}`, userData),
  getInvestorInvestments: (id) =>
    axiosInstance.get(`getInvestorInvestmentsById/${id}`),
  getAllDocuments: (id) => axiosInstance.get(`/getAllDocuments/${id}`),
  getAllImages: (id) => axiosInstance.get(`/getAllImages/${id}`),
  addBankDetails: (id, bankDatas) =>
    axiosInstance.post(`/addBankDetails/${id}`, bankDatas),
  getBankDetails: (id) => axiosInstance.get(`/getBankDetails/${id}`),
  editBankDetails: (id, userData) =>
    axiosInstance.post(`/editBankDetails/${id}`, userData),
  getLegalTeam: () => axiosInstance.get(`/getLegalTeam`),
  getPropertySummary: (id) => axiosInstance.get(`/getPropertySummary/${id}`),
  addMessage: (userData) => axiosInstance.post(`/addMessage`, userData),
  getPaymentPending: (id) => axiosInstance.get(`/getPaymentPending/${id}`),
  getFAQs: () => axiosInstance.get(`getFAQs`),
  getPaymentPendingProperties: (id) =>
    axiosInstance.get(`/getPaymentPendingProperties/${id}`),
  addPayment: (userData) => axiosInstance.post(`/addPayment`, userData),
  getProjectProperties: (id) =>
    axiosInstance.get(`/getProjectProperties/${id}`),
  ProjectDetails: (id) => axiosInstance.get(`/ProjectDetails/${id}`),
  getNotifications: (id) => axiosInstance.get(`getNotificationsById/${id}`),
  getInvestmentRangeById: (id) =>
    axiosInstance.get(`/getInvestmentRangeById/${id}`),
  getMarketTrend: (id) => axiosInstance.get(`/getMarketTrend/${id}`),
  addInvestments: (userData) => axiosInstance.post(`/addInvestments`, userData),
  getTransactionDetails: (id) =>
    axiosInstance.get(`getTransactionDetails/${id}`),
  // getPropertyDetails: (id) => axiosInstance.get(`/getPropertyDetails/${id}`),
  getProjectDetails: (id) => axiosInstance.get(`/getProjectDetails/${id}`),
  updateAvatar: (userData) => axiosInstance.post(`/updateAvatar`, userData),
  getUsersMaster: (id) => axiosInstance.get(`/getUsersMaster/${id}`),
  getWalletBalance: (id) => axiosInstance.get(`/getWalletBalance/${id}`),
  addWithdraw: (data) => axiosInstance.post(`/addwithdraw`, data),
  getThemeColors: (currentTheme) =>
    axiosInstance.get(`/getWebsiteThemeColors/${currentTheme}`),
  updateProfile: (id, userData) =>
    axiosInstance.post(`updateProfile/${id}`, userData),
  addWalletBalance: (userData) =>
    axiosInstance.post(`addWalletBalance`, userData),
  getProjectImagesById: (id) =>
    axiosInstance.get(`/getProjectImagesById/${id}`),
  getProjectDocumentsById: (id) =>
    axiosInstance.get(`/getProjectDocumentsById/${id}`),
  addWalletPayment: (userData) =>
    axiosInstance.post(`addWalletPayment`, userData),
  getInvestmentStats: () => axiosInstance.get(`/getInvestmentStats`),
   markAsRead: (id) => axiosInstance.post(`markAsRead/${id}`),
  getUnreadCount: (id) => axiosInstance.get(`getUnreadCount/${id}`),
  uploadKyc: (formData) => axiosInstance.post(`uploadKyc`, formData),
  getKycDetails: (userId) => axiosInstance.get(`/getKycDetails/${userId}`),
  getAllProperties: () => axiosInstance.get(`getAllProperties`),
  addSiteVisit:(data)=>axiosInstance.post(`addSiteVisit`,data),
  addHelpMessage: (data) =>
    axiosInstance.post(`addHelpMessage`,data),
  getSubscriptionPlans: () => axiosInstance.get(`/getSubscriptionPlans`),
  addSubscription: (userdata) =>
    axiosInstance.post(`/addSubscription`, userdata),
  getSubscriptionsById: (userId) =>
    axiosInstance.get(`/getSubscriptionsById/${userId}`),
  updateSubscriptionStatus: (userId) =>
    axiosInstance.post(`/updateSubscriptionStatus/${userId}`),

  getImagesByPropertyId: (propertyId) =>
    axiosInstance.get(`/getImagesByPropertyId/${propertyId}`),
  deleteNotificationById:(notificationId)=>axiosInstance.delete(`deleteNotificationById/${notificationId}`),
 
  getUserSubscriptionStatus: (userId) =>
    axiosInstance.get(`/getUserSubscriptionStatus/${userId}`),
  SiteVisitStore: (data) => axiosInstance.post(`/SiteVisitStore`, data),
   getThemeColors: (currentTheme) => axiosInstance.get(`/getWebsiteThemeColors/${currentTheme}`),
   getAllPropertiesAndProjects:()=>axiosInstance.get(`/getAllPropertiesAndProjects`),
   getNearbyProperties:(params)=>axiosInstance.get(`/getNearbyProperties`,{params}),
   deleteAllNotifications:(userId)=>axiosInstance.delete(`/deleteAllNotifications/${userId}`),
   getBookedProperties:(userId)=>axiosInstance.get(`/getBookedProperties/${userId}`),
   addAdvancePayment:(data)=>axiosInstance.post(`/addAdvancePayment`,data),
   getApartmentPlotsById:(id)=>axiosInstance.get(`/getApartmentPlotsById/${id}`),
   getApartmentImagesById:(id)=>axiosInstance.get(`/getApartmentImagesById/${id}`),
   addDocumentRequests:(data)=>axiosInstance.post('/addDocumentRequests',data),
   getPropertyDocumentStatus: (data) => 
  axiosInstance.get(`/getPropertyDocumentStatus`, { params: data }),
   villaDetailsChange: (data) => axiosInstance.post(`/villaDetailsChange`, data),
   getRecentProperties:(data)=>axiosInstance.get(`/getRecentProperties`,{params:data}),
   createRazorpayOrder: (payload) => axiosInstance.post('/createOrder', payload),
   confirmAdvancePayment:(payload)=>axiosInstance.post('/confirmAdvancePayment',payload),
   checkActiveSubscription:(payload)=>axiosInstance.post('/checkActiveSubscription',payload),
    // createRazorpayOrder:(payload)=>axiosInstance.post(`/createRazorpayOrder`,payload),
   confirmSubscriptionPayment:(payload)=>axiosInstance.post(`/confirmSubscriptionPayment`,payload),
   createOrder:(payload)=>axiosInstance.post(`/createRazorpayOrder`,payload),
   getApartmentDocumentsById:(apartmentId) =>axiosInstance.get(`/getApartmentDocumentsById/${apartmentId}`),
   verifyUser:(token,encryptedUserId)=>axiosInstance.get(`/verifyUser/${token}/${encryptedUserId}`),
   resendVerification:(data)=>axiosInstance.post(`/resendVerification`,data),
   saveFcmToken:(data)=>axiosInstance.post(`/saveFcmToken`,data),
   getPropertyVideos: (data) =>
  axiosInstance.get('/getPropertyVideos', {
    params: {
      type: data.type,
      reference_id: data.reference_id,
    },
  }),
  filterProperties:(data)=>axiosInstance.post(`/filter-properties`, data)
};

const vendorApi = {
  addPropertyByVendorId: (propertyData) =>
    axiosInstance.post(`addPropertyByVendorId`, propertyData),
  addDocuments: (data) => axiosInstance.post(`addDocuments`, data),
  getAllPropertiesByVendorId: (vendorId) =>
    axiosInstance.get(`getAllPropertiesByVendorId/${vendorId}`),
  updateMarketPrice: (data) => axiosInstance.post(`updateMarketPrice`, data),
  updatePropertyById: (data) => axiosInstance.post(`updatePropertyById`, data),
  getProjectById:(Id)=>axiosInstance.get(`/getProjectById/${Id}`),
  addProjectUserMapping:(data)=>axiosInstance.post(`addProjectUserMapping`,data),
  updateVendorMarketPrice:(data)=>axiosInstance.post(`updateVendorMarketPrice`,data),
  addPlot:(data)=>axiosInstance.post(`/addPlot`,data),
  addImagesById:(data)=>axiosInstance.post(`/addImagesById`,data),
  deleteImageById: (data) => axiosInstance.post('/deleteImageById', data),
  addProjectDocuments:(documentData) => axiosInstance.post(`/addProjectDocuments`,documentData),
  getDocumentsById: (params) => axiosInstance.get('/getDocumentsById', { params }),
  addApartmentDocuments:(data)=>axiosInstance.post(`/addApartmentDocuments`,data),
  getAllAdvertisement:()=>axiosInstance.get(`/getAllAdvertisement`),
  deleteDocumentById:(payload)=>axiosInstance.delete(`/deleteDocumentById`,{ data: payload }),
  editApartmentDetails:(data)=>axiosInstance.post(`/editApartmentDetails`,data),
  updatePropertyPriceByVendor:(data)=>axiosInstance.post('/updatePropertyPriceByVendor',data),

  storeSubscription:(data)=>axiosInstance.post('/storeSubscription',data),
  getFlatById:(apartmentId,id)=>axiosInstance.get(`/getFlatById/${apartmentId}/${id}`),
  vendorAddFlat: (data) => axiosInstance.post(`/vendorAddFlat`, data),
};

export { investorApi, api, vendorApi };
